import axiosInstance from "../axiosInstance";

export const PUTCompletarReuIngreso = async (idOpe) => {
  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/completar-reu-ingreso/${idOpe}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: 500,
      message: error.message || "Error al confirmar el artículo en REU",
    };
  }
};

export default PUTCompletarReuIngreso;
